// utils > Constants
export const numDaysInMonth = Object.freeze([31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]) // zero indexed for use with Date.getMonth()
